import Vant from "vant";
import "vant/lib/index.css";
import Vue from "vue";
import App from "./App.vue";
import "./assets/styles/base.scss";
import components from "./components";
import router from "./router";
import store from "./store";
import mixin from "./utils/mixin";
import "./utils/rem";
import Bridge from "./utils/bridge.js";

// 初始化 Bridge
Vue.prototype.$bridge = Bridge;

// 注册全局组件
Object.keys(components).forEach((key) => {
  Vue.component(components[key].name, components[key]);
});

// 注册 Vant
Vue.use(Vant);
Vue.mixin(mixin);

// 防止重复点击指令
Vue.directive("prevent-reclick", {
  inserted(el, binding) {
    const delay = binding.value || 3000;
    el.addEventListener("click", (e) => {
      if (el.classList.contains("is-disabled")) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      el.classList.add("is-disabled");
      el.style.pointerEvents = "none";
      setTimeout(() => {
        el.classList.remove("is-disabled");
        el.style.pointerEvents = "";
      }, delay);
    });
  },
});

// 初始化 Vue
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// 路由守卫
router.beforeEach((to, from, next) => {
  if (window._hmt) {
    window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
  }
  next();
});
